<mat-tab-group (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex">
    <mat-tab label="My Connections"></mat-tab>
    <mat-tab label="Create Connection"></mat-tab>
</mat-tab-group>

<div style="margin-top: 1rem">
    <router-outlet />
</div>
